import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";
import {
    AntiRatingParams,
    BranchesAntiRatingResponse,
    TripsAntiRatingResponse,
} from "interfaces/entities/ticketStats";

type Options = { enabled?: boolean };

// Антирейтинг филиалов: сортировка по убыванию числа обращений
export const useBranchesAntiRating = (
    params: AntiRatingParams = {},
    options: Options = {}
) => {
    const orgID = localStorage.getItem("orgID") || "";
    const { enabled = true } = options;

    return useQuery<BranchesAntiRatingResponse>({
        queryKey: ["branches-anti-rating", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getBranchesAntiRating(params);
            return response.data;
        },
        enabled,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};

// Антирейтинг поездок (групповых поездок) по количеству обращений
export const useTripsAntiRating = (
    params: AntiRatingParams = {},
    options: Options = {}
) => {
    const orgID = localStorage.getItem("orgID") || "";
    const { enabled = true } = options;

    return useQuery<TripsAntiRatingResponse>({
        queryKey: ["trips-anti-rating", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getTripsAntiRating(params);
            return response.data;
        },
        enabled,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
